// Parses YouTube / Vimeo URLs (watch, embed, shorts, live, youtu.be) into a
// normalized shape shared by the player iframe and the VideoObject schema.
// `playerUrl` is the privacy-enhanced URL used in iframes (youtube-nocookie);
// `embedUrl` is the canonical embed URL Google expects in structured data.
export function parseVideoUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, '');
    const segments = u.pathname.split('/').filter(Boolean);

    if (host === 'youtube.com' || host === 'youtube-nocookie.com' || host === 'm.youtube.com') {
      let id = u.searchParams.get('v');
      if (!id && (segments[0] === 'embed' || segments[0] === 'shorts' || segments[0] === 'live')) {
        id = segments[1] ?? null;
      }
      return id ? youtubeVideo(id) : null;
    }
    if (host === 'youtu.be') {
      return segments[0] ? youtubeVideo(segments[0]) : null;
    }
    if (host === 'vimeo.com' || host === 'player.vimeo.com') {
      const id = segments[segments.length - 1];
      return id ? vimeoVideo(id) : null;
    }
  } catch {
    return null;
  }
  return null;
}

function youtubeVideo(id) {
  return {
    platform: 'youtube',
    id,
    embedUrl: `https://www.youtube.com/embed/${id}`,
    playerUrl: `https://www.youtube-nocookie.com/embed/${id}`,
    watchUrl: `https://www.youtube.com/watch?v=${id}`,
    // maxresdefault is not generated for every video; hqdefault always exists
    thumbnailUrls: [
      `https://img.youtube.com/vi/${id}/maxresdefault.jpg`,
      `https://img.youtube.com/vi/${id}/hqdefault.jpg`,
    ],
  };
}

function vimeoVideo(id) {
  return {
    platform: 'vimeo',
    id,
    embedUrl: `https://player.vimeo.com/video/${id}`,
    playerUrl: `https://player.vimeo.com/video/${id}`,
    watchUrl: `https://vimeo.com/${id}`,
    // Vimeo thumbnails are only available via their oEmbed API, so none here
    thumbnailUrls: [],
  };
}
